import React, { useEffect, useState, useRef } from "react";
import FAWrapper from "components/vendors/fa-wrapper";
import { useMediaQuery } from "@react-hook/media-query";

const Slider = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);

  // Same visible items for both mobile and desktop
  const visibleItems = 4;

  // Check if navigation buttons should be disabled
  const canGoNext = currentIndex < items.length - visibleItems;
  const canGoPrev = currentIndex > 0;

  const handleNext = () => {
    if (!canGoNext) return;
    setCurrentIndex((prev) => {
      if (prev >= items?.length - visibleItems) {
        return 0; // Loop back to beginning
      }
      return prev + 1;
    });
  };

  const handlePrev = () => {
    if (!canGoPrev) return;
    setCurrentIndex((prev) => {
      if (prev <= 0) {
        return items?.length - visibleItems; // Loop to end
      }
      return prev - 1;
    });
  };

  useEffect(() => {
    if (currentIndex < 0) {
      const timeout = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(items?.length - visibleItems);
      }, 500);

      return () => clearTimeout(timeout);
    }

    if (currentIndex > items?.length - visibleItems) {
      const timeout = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(0);
      }, 500);

      return () => clearTimeout(timeout);
    }

    setIsTransitioning(true);
  }, [currentIndex, items?.length, visibleItems]);

  return (
    <div className="slider-container">
      <div 
        className={`nav-btn ${!canGoPrev ? 'disabled' : ''}`} 
        onClick={handlePrev}
        disabled={!canGoPrev}
      >
        <FAWrapper icon="chevron-left" className="sm" />
      </div>

      <div className="slider-wrapper" style={{ overflow: "hidden" }}>
        <div
          ref={sliderRef}
          className="slider"
          style={{
            transform: `translateX(-${(currentIndex * 100) / visibleItems}%)`,
            display: "flex",
            transition: isTransitioning ? "transform 0.5s ease-in-out" : "none",
          }}
        >
          {items?.map((logo, index) => (
            <div
              className="slider-item-container"
              key={`slider${index}`}
              style={{ flex: `0 0 ${100 / visibleItems}%` }}
            >
              <img
                src={logo.src}
                className="mkt-partner-logo"
                alt={`logo-${index}`}
              />
            </div>
          ))}
        </div>
      </div>

      <div 
        className={`nav-btn ${!canGoNext ? 'disabled' : ''}`} 
        onClick={handleNext}
        disabled={!canGoNext}
      >
        <FAWrapper icon="chevron-right" className="sm" />
      </div>
    </div>
  );
};

export default Slider;
